var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1881.35 156.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ad7c43;}.cls-2{fill:#f59829;}.cls-3{fill:#c79858;}.cls-4{fill:#ffbf6d;}.cls-5{fill:#de8b21;}.cls-6{fill:#b68356;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tobi"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 460.12,
    y: 79.24,
    width: 27.63,
    height: 76.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 539.42,
    y: 25.18,
    width: 22.23,
    height: 130.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.62,
    y: 79.84,
    width: 22.83,
    height: 76.19
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0 57.62 174.53 3.55 565.85 3.55 481.15 57.62 0 57.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0 57.62 0 90.05 479.35 90.05 481.15 57.62 0 57.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "479.35 90.05 565.85 22.48 565.85 3.55 481.15 57.62 479.35 90.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M93.11,121.89V31.19a30,30,0,0,1,30-30H312.06a32.14,32.14,0,0,1,32.13,32.14v83.19l-4.2,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M88.9,122.49V31.79a30,30,0,0,1,30-30H307.85A32.14,32.14,0,0,1,340,33.89v88.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146,63.62h0a12,12,0,0,1,12,12v79.42H135.15V74.43A10.81,10.81,0,0,1,146,63.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.16,63.92h0a12,12,0,0,1,12,12v79.42H133.35V74.74A10.81,10.81,0,0,1,144.16,63.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M273.27,64.54h0a10.85,10.85,0,0,1,10.85,10.85V156H261.3V76.51A12,12,0,0,1,273.27,64.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M271.47,64.59h0a10.85,10.85,0,0,1,10.85,10.85V156H259.5V76.56A12,12,0,0,1,271.47,64.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1404.4,
    y: 77.44,
    width: 27.63,
    height: 77.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1835.99,
    y: 77.44,
    width: 27.63,
    height: 77.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1618.85,
    y: 20.67,
    width: 27.63,
    height: 134.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1266.99,
    y: 18.65,
    width: 27.63,
    height: 136.71
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1252.43 3.55 1635.37 1.75 1881.35 57.62 1391.19 62.12 1252.43 3.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1252.43 3.55 1252.43 25.18 1391.19 90.05 1391.19 62.12 1252.43 3.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1391.19 62.12 1881.35 57.62 1881.35 90.05 1391.19 90.05 1391.19 62.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1766.6,120.74V30c0-16.58-14.2-30-31.71-30H1535.42c-18.74,0-33.93,14.39-33.93,32.14v83.19l4.44,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1771,121.34V30.63c0-16.58-14.2-30-31.71-30H1539.86c-18.74,0-33.93,14.39-33.93,32.14v88.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1710.79,62.47h0c-7,0-12.69,5.38-12.69,12v79.43h24.1V73.28C1722.2,67.31,1717.09,62.47,1710.79,62.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1712.69,62.77h0c-7,0-12.68,5.38-12.68,12v79.42h24.1V73.58C1724.11,67.61,1719,62.77,1712.69,62.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1576.37,63.39h0c-6.32,0-11.46,4.86-11.46,10.85v80.59H1589V75.36C1589,68.75,1583.36,63.39,1576.37,63.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1578.28,63.44h0c-6.33,0-11.46,4.86-11.46,10.85v80.59h24.1V75.41C1590.92,68.8,1585.26,63.44,1578.28,63.44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 741.85,
    y: 79.24,
    width: 27.63,
    height: 76.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1143.1,
    y: 79.24,
    width: 27.63,
    height: 76.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1083.64,
    y: 23.98,
    width: 22.23,
    height: 131.38
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "749.65 3.55 1098.05 3.55 1185.75 57.62 729.23 57.62 749.65 3.55"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 729.23,
    y: 57.62,
    width: 456.52,
    height: 32.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M829.85,122.49V31.79a30,30,0,0,1,30-30H1048.8a32.14,32.14,0,0,1,32.13,32.14v88.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M885.11,63.92h0a12,12,0,0,1,12,12v79.42H874.3V74.74A10.81,10.81,0,0,1,885.11,63.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1012.41,64.59h0a10.81,10.81,0,0,1,10.86,10.78v80h-22.83V76.47A11.93,11.93,0,0,1,1012.41,64.59Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset24);
export default __webpack_public_path__ + "static/media/asset24.528f5248a5419c448dc6f39ac3d5f91a.svg";
export { ForwardRef as ReactComponent };